import { brandApp, brandTokens } from '@cyberscore/contracts';
import type { CSSProperties } from 'react';
import type { Tenant } from './session';

/**
 * The tenant's colour as inline custom properties for its app's root (task 97, decision 0073). With no
 * colour of its own or the platform's, nothing is set and the stylesheet's defaults apply: the staff app's
 * teal, the business owners' blue.
 */
export function brandStyle(
  tenant: Pick<Tenant, 'brand' | 'kind'> | null | undefined,
): CSSProperties | undefined {
  if (!tenant?.brand) return undefined;
  return brandTokens(tenant.brand, brandApp(tenant.kind)) as CSSProperties;
}
